import React from 'react';
import { Button } from '@mui/material';

import Screen from '../Screen';
import Form from '../Form';
import InputPhone from '../InputPhone';
import ButtonPrimary from '../ButtonPrimary';

import useForm from './useForm';

const PhoneUpdate = ({ onDone }) => {
  const {
    form,
    isSubmitting,
    handleSubmit,
  } = useForm(onDone);

  return (
    <Screen
      header="Update your mobile number."
      subheader="A new verification code will be sent."
    >
      <Form
        form={form}
        onSubmit={handleSubmit}
      >
        <InputPhone />
        <ButtonPrimary isLoading={isSubmitting}>
          Update and Send New Code
        </ButtonPrimary>
      </Form>
      <Button
        fullWidth
        onClick={onDone}
        variant="text"
      >
        Back
      </Button>
    </Screen>
  );
};

export default PhoneUpdate;
